import { motion } from 'motion/react'
import { ActivationSecurityPanel } from './ActivationSecurityPanel'

type ActivationRecoveryIntroProps = {
  leftEyebrow: string
  leftTitle: string
  leftSubtitle: string
  nextStepsTitle: string
  nextSteps: string[]
  trustNote: string
  securityPanelTitle: string
  securityPanelItems: string[]
  prefersReducedMotion: boolean
}

export const ActivationRecoveryIntro = ({
  leftEyebrow,
  leftTitle,
  leftSubtitle,
  nextStepsTitle,
  nextSteps,
  trustNote,
  securityPanelTitle,
  securityPanelItems,
  prefersReducedMotion,
}: ActivationRecoveryIntroProps) => (
  <div className="space-y-5">
    <div className="space-y-2.5">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-(--color-status-info)">{leftEyebrow}</p>
      <h1 className="max-w-[22ch] text-balance text-3xl font-semibold tracking-tight text-(--color-text-primary) sm:text-[2.25rem] lg:max-w-none lg:text-[2.45rem] lg:whitespace-nowrap">
        {leftTitle}
      </h1>
      <p className="max-w-[64ch] text-sm leading-relaxed text-(--color-text-secondary) sm:text-base">{leftSubtitle}</p>
    </div>

    <div className="space-y-3 border-y border-[color-mix(in_srgb,var(--color-border-default)_78%,transparent)] py-3">
      <h2 className="text-sm font-semibold tracking-tight text-(--color-text-primary)">{nextStepsTitle}</h2>
      <ul className="space-y-2">
        {nextSteps.map((item, index) => (
          <motion.li
            key={item}
            initial={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: prefersReducedMotion ? 0.12 : 0.18,
              delay: prefersReducedMotion ? 0 : index * 0.04,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="flex items-start gap-2.5 rounded-xl px-1.5 py-1 text-sm text-[color-mix(in_srgb,var(--color-text-secondary)_86%,var(--color-text-primary))]"
          >
            <span className="mt-[2px] inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[color-mix(in_srgb,var(--color-status-success)_28%,transparent)] bg-[color-mix(in_srgb,var(--color-status-success)_15%,transparent)] text-(--color-status-success)">
              <svg viewBox="0 0 20 20" className="h-3.5 w-3.5 fill-none stroke-current stroke-[2.2]" aria-hidden>
                <path d="m4.5 10.4 3.3 3.3 7.2-7.2" />
              </svg>
            </span>
            <span>{item}</span>
          </motion.li>
        ))}
      </ul>
    </div>

    <p className="max-w-[62ch] text-xs leading-relaxed text-[color-mix(in_srgb,var(--color-text-muted)_92%,var(--color-text-secondary))]">
      {trustNote}
    </p>

    <ActivationSecurityPanel title={securityPanelTitle} items={securityPanelItems} />
  </div>
)
